import { LovCompanyCodeListDTO } from '@api/ringil-api.v2.tsx';

export const formatAddress = (countryCode3: string, zipCode: string, city: string, streetNr: string) => {
  // 'CZ, 412 01 Litoměřice, Rooseveltova 11'
  return `${countryCode3}, ${zipCode} ${city}, ${streetNr}`;
};

/**
 * Label for a company code-list option: '<externalId> - <name>', collapsing to just the
 * externalId when the name is missing or identical to it (id and name are the same).
 */
export const formatCompanyCodeListLabel = (option: Pick<LovCompanyCodeListDTO, 'externalId' | 'name'> | null | undefined): string => {
  if (!option) return '';
  return option.name && option.name !== option.externalId ? `${option.externalId} - ${option.name}` : option.externalId;
};
